import axios from 'axios';

export function putTopic(topicId, property, value) {
  return () => {
    axios.put(`/admin/topic/${topicId}`, { property, value }).catch((error) => {
      console.error(error);
    });
  };
}
